import { breadcrumbSlot } from "@redotech/arbiter/breadcrumb";
import {
  MARKETING_ANALYTICS_TABS_URL_PARAM,
  MarketingAnalyticsPage,
} from "@redotech/redo-merchant-analytics-app/analytics/marketing/marketing-analytics-params";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { overviewRoutes } from "../../../homepage/route";
import { plgHomeRoutes } from "../../../plg-homepage/route";
import { TranslatedBreadcrumbLabel } from "../../../return/returns-breadcrumb-label";
import { defaultChildRoute } from "./legacy-redirects";
import { plgProductsRoutes } from "./plg-products-routes";

const TRY_FIRST_ANALYTICS_ROUTE = "analytics/try-first";
const MARKETING_ANALYTICS_ROUTE = "analytics/marketing";

const FULLSCREEN_ROUTES: string[] = [];
const homeBreadcrumb = breadcrumbSlot();

export function hidePadding(url: string, search: { search: string }) {
  if (FULLSCREEN_ROUTES.some((route) => url.includes(route))) {
    return true;
  }

  if (
    url.includes(MARKETING_ANALYTICS_ROUTE) &&
    new URLSearchParams(search.search).get(
      MARKETING_ANALYTICS_TABS_URL_PARAM,
    ) === MarketingAnalyticsPage.BACK_IN_STOCK
  ) {
    return true;
  }

  return url.includes(TRY_FIRST_ANALYTICS_ROUTE);
}

export function hideHeader(url: string): boolean {
  return FULLSCREEN_ROUTES.some((route) => url.includes(route));
}

export function hideNavbar(url: string): boolean {
  return FULLSCREEN_ROUTES.some((route) => url.includes(route));
}

export const homeRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: homeBreadcrumb },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <>
            <TranslatedBreadcrumbLabel
              breadcrumb={homeBreadcrumb}
              getLabel={(t) => t("Home")}
            />
            <Page
              hideHeader={hideHeader}
              hideNavbar={hideNavbar}
              hidePadding={hidePadding}
            />
          </>
        ),
      };
    },
    children: [
      defaultChildRoute("overview"),
      { path: "overview", children: overviewRoutes },
      { path: "plg-home", children: plgHomeRoutes },
      { path: "plg-products", children: plgProductsRoutes },
    ],
  },
];
